
import StockKChart from './StockKChart';
const myHolding = ['SMH', 'RKLB', '0700.HK', 'U', 'TSLA',
    'GOOG', 'QQQ', 'MSFT', 'SPLG', 'ISRG', 'ICLN']
export default function StockKList(prop) {
    let style = {
        header: {
            fontSize: '5vw'
        },
        container: {
            border: 'solid black',
            width: "95vw",
            padding: "2.5vh",
            overflow: "visible"
        },

        headerContainer: {
            display: "flex",
            padding: "5px",
            margin: "5px",
        },
        label: {
            flex: 2,
            margin: "2px",
            fontSize:"2.5vw",
            "textAlign": "center",
            "alignSelf": "center",
        },
        chg: {
            flex: 1,
            margin: "2px",
            fontSize:"2.5vw",
            "textAlign": "center",
            "alignSelf": "center"
        },
        chart: {
            "textAlign": "center",
            fontSize:"2.5vw",
            //flex: 10,
            margin: "2px",
            width: "50vw",
        }

    }
    let symbolList = prop.symbolList;
    let itemList = symbolList.map(x => <div key={x + 'k chart'}>
        < StockKChart label={x} /></div>)
    return (
        <section>
            <div style={style.container}>
                <div style={style.header}>   {prop.name} </div>

            <div style={style.headerContainer}>
                <div style={style.label} >LABEL</div>
                <div style={style.chg}>PRICE</div>
                <div style={style.chg}>C1</div>
                <div style={style.chg}>C5</div>
                <div style={style.chg}>C20</div>
                <div style={style.chart}>CHART</div>
            </div>
                {itemList}
            </div>
        </section>
    )
}